import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Alert from 'packages/ui/Alert';
import Loading from './Loading';

const PageInside = styled('main')`
  background-color: #fff;
  border-right: 1px solid #f5f5f5;
  min-height: 100vh;
  padding: 20px 50px 150px;
`;

const PageWrapper = styled('div')`
  min-width: 1000px;
  overflow-x: auto;
`;

const Title = styled.h1`
  color: #777;
  font-size: 14px;
  font-weight: normal;
  line-height: 24px;
  margin: 0;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
`;

const Container = styled('div')`
  ${props => props.size === 'small' && 'max-width: 850px;'}
`;

const Main = styled('div')`
  flex-grow: 1;
  margin-left: 50px;
`;

const Aside = styled('div')`
  position: sticky;
  top: 20px;
`;

const AsideWrapper = styled('div')`
  max-width: 280px;
  min-width: 280px;
  width: 280px;
`;

const ContainerWithSidebar = styled('div')`
  display: flex;
  flex-direction: row;
  ${props => props.size === 'small' && 'max-width: 600px;'}
`;

function Sidebar({ children }) {
  return (
    <AsideWrapper>
      <Aside>{children}</Aside>
    </AsideWrapper>
  );
}

function Error({ description, title }) {
  return <Alert mood="error" title={title} description={description} />;
}

function Page({ children }) {
  return (
    <PageWrapper>
      <PageInside>{children}</PageInside>
    </PageWrapper>
  );
}

Container.propTypes = {
  size: PropTypes.oneOf(['small', 'fluid'])
};

Container.defaultProps = {
  size: 'fluid'
};

export {
  Container,
  ContainerWithSidebar,
  Error as PageError,
  Header as PageHeader,
  Loading as PageLoading,
  Main,
  Title as PageTitle,
  Sidebar
};

export default Page;
